import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'
import cls from './CropperModal.module.css'

import { fixImageRotation } from 'helpers/images'
import GenericBtnModal from '../GenericBtnModal'

const CropperModal = ({ image, aspectRatio, cropperShape, autoCrop, onSave, onClose }) => {
  const cropperRef = useRef(null)
  const autoCropRef = useRef(null)
  const [imageUrl, setImageUrl] = useState()

  const cropperShapeModalClass = useMemo(
    () => (cropperShape === 'circle' ? cls.circleCropper : ''),
    [cropperShape]
  )

  useEffect(() => {
    if (!image) {
      return
    }

    setImageUrl()
    fixImageRotation(image).then(setImageUrl)
  }, [image])

  const handleSave = useCallback(() => {
    if (autoCropRef.current) {
      return
    }

    autoCropRef.current = autoCrop
    const imageElement = cropperRef?.current
    const cropper = imageElement?.cropper
    const dataUrl = cropper.getCroppedCanvas().toDataURL('image/jpeg', 0.7)

    setTimeout(
      () => {
        onSave(dataUrl)
      },
      autoCrop ? 500 : 0
    )
  }, [cropperRef, onSave, autoCrop])

  return (
    <GenericBtnModal
      showModal={!!image}
      title="Crop Image"
      btnText="Save"
      modalBtnFunction={handleSave}
      modalClosed={onClose}
      classNames={{
        modal: classnames('w-2/3 h-auto max-w-none', {
          hidden: autoCrop,
        }),
        content: classnames('w-full max-w-full', cls.cropperModal, cropperShapeModalClass),
      }}
    >
      {imageUrl && (
        <div className="relative mb-4">
          <Cropper
            src={imageUrl}
            className={cls.cropper}
            style={{ width: '100%' }}
            aspectRatio={aspectRatio}
            guides={false}
            dragMode={'move'}
            viewMode="1"
            ref={cropperRef}
            autoCropArea={1}
            crop={autoCrop ? handleSave : undefined}
          />
        </div>
      )}
    </GenericBtnModal>
  )
}

CropperModal.propTypes = {
  image: PropTypes.object,
  aspectRatio: PropTypes.number,
  cropperShape: PropTypes.oneOf(['circle']),
  onSave: PropTypes.func,
  onClose: PropTypes.func,
}

export default CropperModal
